<template>
  <!-- x修改凭证  -->
  <el-dialog :title="title" :visible.sync="XG_voucherShow" width="1200px" append-to-body :close-on-click-modal="false"
    @close="cancel" class="newDialog">
    <div class="Voucher_OverFLow" v-loading="XG_Voucer_loading" :element-loading-text="XG_voucherShow_Text">
      <div class="btn-grooup">
        <el-button :class="item.icon" v-for="(item, index) in buttonList1" size="small" @click="handlerMenus(item.name)"
          :key="item.id">{{ item.name }}</el-button>

        <!-- 标记 -->
        <el-popover placement="bottom" width="320" v-model="nowPopoverShow" popper-class="queryVoucher_mark"
          trigger="manual">
          <div>
            <el-radio v-model="nowId" v-for="i in markList" :label="i.id" :key="i.id"
              @change="handleRadioChange(row, $event)">
              <i class="iconfont iconlastTime" :style="{ fontSize: '20px', color: i.color }"></i>
            </el-radio>
          </div>
          <div class="mark_item">
            <el-input type="textarea" maxlength="80" show-word-limit placeholder="请输入标记原因" v-model="nowReason"
              resize="none" @focus="handleInputFocus" :autosize="{ minRows: 3, maxRows: 6 }"></el-input>
          </div>
          <div style="text-align: center" class="mark_item">
            <el-button size="small" @click="nowPopoverShow = false">取消</el-button>
            <el-button size="small" @click="saveMarks" type="primary">确认</el-button>
          </div>

          <el-button size="small" v-if="XG_voucherShow && openButtonSend" style="margin-left: 10px" class="markButton"
            @click="nowPopoverShow = !nowPopoverShow" slot="reference">
            <!-- 提示标记原因 -->
            <el-tooltip class="item" effect="light" placement="bottom" :visible-arrow="false" transition="null"
              v-if="nowReason">
              <span slot="content">{{ nowReason ? nowReason : "无" }}</span>
              <span>
                <i class="iconfont iconlastTime markButtonIcon" :style="retunMarkStyles(nowId)"></i>
                标记
              </span>
            </el-tooltip>
            <!-- 没有标记原因则不提示 -->
            <span v-else>
              <i class="iconfont iconlastTime markButtonIcon" :style="retunMarkStyles(nowId)"></i>
              标记
            </span>
            <!-- <span class='tooltips_c' v-if='nowReason'>
				    				{{nowReason}}
				    			</span> -->
          </el-button>

          <!-- 	<el-button size="small" v-if='XG_voucherShow&&openButtonSend&&!nowReason'  style='margin-left: 7px;' class='markButton'  @click='nowPopoverShow=!nowPopoverShow' slot="reference">
				    	<i  class='iconfont iconlastTime markButtonIcon' :style='retunMarkStyles(nowId)'></i>
				    		标记
				    	</el-button> -->
        </el-popover>

        <!-- 标记结束 -->
      </div>
      <voucher-content :voucherData="Voucher_Chief_Data" :superData_fapiao="superData_fapiao"
        :XG_voucherShows="XG_voucherShow" :openButtonSend="openButtonSend" @sendMarkMessage="sendMarkMessage" @close = "XG_voucherShow = false"
        @on-submit-success="successAjax($event, 'XG_voucherShow')"
        @refreshTable = "$emit('refreshTable')"
        :hideBtn="hideBtn"
        @on_save_voucher_fp="backVoucherData">
        <!-- <template #saveBtn>
          保存
        </template> -->
        </voucher-content>
    </div>
  </el-dialog>
</template>

<script>
import voucherContent from "@/components/table/voucherTableContent";

export default {
  props: ["visible", "row", "closeModel", "openButton_s", 'voucherTitle','hideBtn'],
  data() {
    return {
      title: '修改凭证',
      nowPopoverShow: false, // 标记显示
      nowId: "",
      nowReason: "",
      markList: [
        { id: "1", color: "#999" },
        { id: "2", color: "green" },
        { id: "3", color: "#f5a623" },
        { id: "4", color: "#e5691f" },
        { id: "5", color: "#d0021b" },
      ],
      openButtonSend: false, // 是否打开翻页
      superData_fapiao: {},
      XG_voucherShow: false, //修改凭证modal
      XG_Voucer_loading: false,
      XG_voucherShow_Text: "查询凭证详情中",
      Voucher_Chief_Data: {},
      buttonList1: [],
      ids: "",
    };
  },
  components: {
    voucherContent,
  },
  computed: {},
  methods: {
    // 得到焦点全选文字
    handleInputFocus(e) {
      e.target.select();
    },
    // 上一张下一张数据
    sendMarkMessage(data) {
      this.nowReason = data.signReason;
      this.nowId = data.signId ? data.signId.toString() : "";
    },
    handleRadioChange(row, val) {
      this.nowReason = row.signReason;
      // if(val!=1) {
      // }else {
      // 	this.nowReason = "";
      // }
    },
    // 返回标记颜色
    retunMarkStyles(signId) {
      let params = {
        cursor: "pointer",
        marginRight: "5px",
        color: "",
      };
      switch (signId) {
        case "1":
          params.color = "#999";
          break;
        case "2":
          params.color = "green";
          break;
        case "3":
          params.color = "#f5a623";
          break;
        case "4":
          params.color = "#e5691f";
          break;
        case "5":
          params.color = "#d0021b";
          break;
      }
      return params;
    },
    // 保存标记
    saveMarks() {
      try {
        this.nowPopoverShow = false;
        this.$http
          .post("voucherChief/setUpSign", {
            signId: Number(this.nowId),
            signReason: this.nowReason,
            id: this.row.id,
          })
          .then((res) => {
            if (res && res.data.code == 1) {
              this.$message.success(res.data.msg);
              this.row.signId = this.nowId;
              this.row.signReason = this.nowReason;
              this.$emit("successSaveMark", true);
            }
          });
      } catch (e) { }
    },
    // 发票凭证修改返回
    backVoucherData(data) {
      console.log("提交发票数据editVoucher.vue", data);

      this.$emit("on-success-submit", data);
    },
    ///凭证列表修改开始打啊大 ---------------------------------------------------
    // 列表修改操作
    handleModify(row) {
      const _ = this;
      _.$store.commit("UPDATAVOUCHEREDIT", true);
      //_.XG_voucherShow = true;
      if (row.id) {
        _.XG_Voucer_loading = true;
        _.XG_voucherShow_Text = "查询凭证详情中";
        _.$http
          .post("voucherChief/getVoucherChief", {
            id: row.id,
          })
          .then((res) => {
            _.XG_Voucer_loading = false;
            if (res && res.data.code == "1") {
              this.nowReason = res.data.data.signReason;
              this.nowId = res.data.data.signId
                ? res.data.data.signId.toString()
                : "1";
              let list = res.data.data;
              _.ids = list.id;
              list.date = _.$util.formatDate.format(list.date, "yyyy-MM-dd");
              list.isShowNextBtn = true; // 是否显示上一张或者下一张
              _.Voucher_Chief_Data = list;
              let lists = JSON.parse(JSON.stringify(list));
              delete lists.voucherAddendumVoList;
              delete lists.id;
              _.$setSessionStorage("voucher", lists);

              _.auditStatusBtn(res.data.data.auditStatus);
            }
          })
          .catch((e) => {
            _.XG_Voucer_loading = false;
          });
      } else if (row.isGenerate) {
        row.isShowNextBtn = false; // 是否显示上一张或者下一张
        _.Voucher_Chief_Data = row;
      } else {
        console.log("发票数据传入",row)
        this.superData_fapiao = row;
      }
    },
    //凭证保存成功后的回调 ================================
    successAjax(bol, key) {
      const _ = this;
      _[key] = false;
      _.$emit("on-success-submit", true);
    },
    handlerMenus(name) {
      switch (name) {
        case "审核":
          this.handleExamine("audit", "审核", "XG_Voucer_loading");
          break;
        case "反审核":
          this.handleExamine("backAudit", "反审核", "XG_Voucer_loading");
          break;
        case "复制":
          this.copyVoucher();
          break;
        case "删除":
          this.deleteVouch();
          break;
        default:
          this.$message.error("未知操作！");
      }
    },
    auditStatusBtn(status) {
      //获取按钮权限
      const _ = this;
      let arrs = ["ac:voucher:audit", "ac:voucher:copy", "ac:voucher:delete"];
      if (status == "1") {
        arrs = ["ac:voucher:auditback", "ac:voucher:copy", "ac:voucher:delete"];
      }
      _.getButton(arrs, "buttonList1");
    },
    // 获取按钮权限
    getButton(arr, key) {
      let params = {
        permissions: arr.join(","),
      };
      try {
        this.$http.post("sys/menu/findPermissionMenu", params).then((res) => {
          if (res && res.data.code == 1) {
            if (res.data.data.length) {
              this[key] = res.data.data;
            }
          }
        });
      } catch (e) { }
    },
    // 审核 // 反审核
    handleExamine(key, val, loading) {
      const _ = this;
      if (_.row.isCheckOut == 1) {
        _.$message.error("已结账不能审核!");
        return false;
      }
      if (_.ids == "") {
        _.$message.error("请先选择一条数据!");
        return false;
      }
      _[loading] = true;
      _.XG_voucherShow_Text = val + "查询中";
      _.$http
        .post("/voucherChief/auditStatus", {
          auditStatus: key,
          ids: _.ids,
        })
        .then((res) => {
          _[loading] = false;
          if (res && res.data.code == "1") {
            _.$message.success(val + "成功!");
            _.handleModify(_.row); //审核成功后重新查询凭证；
            _.$emit("on-success-submit", true);
          }
        })
        .catch((e) => {
          _[loading] = false;
        });
    }, //复制
    copyVoucher() {
      const _ = this;
      let list = JSON.parse(JSON.stringify(_.Voucher_Chief_Data));
      if (list.voucherAddendumVoList.length > 0) {
        for (let i = 0; i < list.voucherAddendumVoList.length; i++) {
          delete list.voucherAddendumVoList[i].id;
        }
      }
      delete list.id;
      _.$setSessionStorage("copyVoucher", list);
      _.XG_voucherShow = false;
      _.$router.push({
        path: "/addVoucher",
        query: {
          copy: "1",
        },
      });
    },
    deleteVouch() {
      let row = {
        id: this.ids,
      };
      this.deleteVoucher(row);
    },
    // 列表删除凭证操作
    deleteVoucher(row) {
      const _ = this;
      if (_.row.isCheckOut == 1) {
        _.$message.error("已结账不能删除!");
        return false;
      }
      if (_.row.auditStatus == 1) {
        _.$message.error("已审核不能删除!");
        return false;
      }
      try {
        this.$confirm("此操作将删除该条凭证, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          _.XG_Voucer_loading = true;
          _.XG_voucherShow_Text = "删除凭证中";
          this.$http
            .post("voucherChief/deleted", { id: row.id })
            .then((res) => {
              _.XG_Voucer_loading = false;
              if (res && res.data.code == 1) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.XG_voucherShow = false;
                _.$emit("on-success-submit", true);
              }
            })
            .catch((e) => {
              _.XG_Voucer_loading = false;
            });
        });
      } catch (e) { }
    },
    cancel() {
      this.ids = "";
      this.XG_voucherShow = false;
      this.$emit("on-close-dialog", false);
    },
    ///凭证列表修改结束 ---------------------------------------------------
  },
  created() { },
  mounted() { },
  watch: {
    voucherTitle: {
      handler(val) {
        if (!val) return
        this.title = val
      },
      immediate: true
    },
    closeModel(val) {
      if (val) {
        this.XG_voucherShow = false;
      }
    },
    visible: {
      handler(val) {
        const _ = this;
        _.XG_voucherShow = val;
      },
      immediate: true,
    },
    row: {
      handler(val) {
        const rows = this.$lodash.cloneDeep(val)
        if (rows && JSON.stringify(rows) === "{}") {
          return;
        }
        const _ = this;
        this.nowReason = rows.signReason;
        this.nowId = rows.signId;
        _.handleModify(rows);
      },
      deep: true,
      immediate: true,
    },
    openButton_s: {
      handler(val) {
        this.openButtonSend = val;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped="scoped">
/deep/ #voucherTableContent {
  .btns {
    padding: 0 38px;
    text-align: right !important;
  }
  .saveBtn {
    background: #269D7B !important;
  }
  .container{
    padding: 0 38px 0 0!important;
    .tipsd {
      display: flex !important;
      align-items: center !important;
      text-align: right !important;
      .el-form-item__content {
        width: auto !important;
      }
    }
    .fixAbove {
      position:  relative !important;
    }
  }
  .pz_btnGroup {
    margin: 0 !important;
    padding-bottom: 30px !important;
  }
}
.newDialog {
  /deep/ .el-dialog__header {
    padding: 30px 38px 20px !important;
  }
}
.Voucher_OverFLow {
  .btn-grooup {
    padding-left: 38px;
    margin-bottom: 10px;
    .markButton {
      padding: 7px 15px;
      transform: translate(-2px, 2px);
      position: relative;
      z-index: 99;

      .tooltips_c {
        display: none;
        position: absolute;
        bottom: -40px;
        z-index: 9999;
        left: 30px;
        background: #fff;
        padding: 10px 15px;
        font-size: 14px;
        border-radius: 2px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        color: "#333" !important;
      }

      &:hover {
        .tooltips_c {
          display: block;
          color: "#333" !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/table/editVoucher.vue